import React, {FC} from 'react';

import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {getAnalyticsSelectedNamespaceTeam} from '../../../../store/panels/analytics/parameters/analyticsPanelParametersSelectors';
import {BusinessHoursContainer} from '../../businessHours/businessHoursContainer';

/*
 * Props.
 */

interface ReportHeaderDatepickerProps {}

export const ReportHeaderBusinessHours: FC<ReportHeaderDatepickerProps> = () => {
  const selectedTeam = useAppSelector(getAnalyticsSelectedNamespaceTeam);

  if (!selectedTeam) {
    return null;
  }

  return <BusinessHoursContainer namespace={selectedTeam.namespace} />;
};
